import { useState } from 'react'
import { OperateType } from '@/types/aiAsk'
import { BaseSelection } from 'slate'
interface AiWriteState {
  showAns: boolean
  selection: BaseSelection
  top: number // 显示的位置
  w: number // 对话框的宽度
  left: number
  answered: boolean
  operateType: OperateType
}
const useAiWriteState = () => {
  const [writeState, setWriteState] = useState<AiWriteState>({
    showAns: false,
    selection: null,
    top: 0, // 显示的位置
    w: 0, // 对话框的宽度
    left: 0,
    answered: false,
    operateType: OperateType.FORMAL_TONE_REWRITE
  })

  return {
    writeState,
    setWriteState,
  }
}

export default useAiWriteState
